import {fadeIn, fadeOut, fetchData} from "../../utils/common";
import {AddCartTypes, KeyboardKeys} from "../../utils/consts";
import {changeAmountCount} from "../cart";

const addCart = ({state}) => {
  const addCartButton = document.querySelector(`.js-add-cart`);
  const informPopupElement = document.querySelector(`.js-popup-add-cart`);

  const URL = `/basket/add`;
  // const URL = `/data/data.json`;

  let timer;

  const showInformPopup = () => {
    fadeIn(informPopupElement, 100, `flex`);

    timer = setTimeout(() => {
      hideInformPopup();
    }, 2000);
  };

  const hideInformPopup = () => {
    fadeOut(informPopupElement, 100);
    clearTimeout(timer);
    informPopupElement.removeEventListener(`click`, hideInformPopup);
    document.removeEventListener(`keydown`, onKeyDownEscape);
  };

  const onPopupClick = (evt) => {
    if (
      evt.target.classList.contains(`js-popup-inform-close`) ||
      evt.target.closest(`.js-popup-inform-close`) ||
      evt.target === evt.currentTarget
    ) {
      hideInformPopup();
    }
  };

  const onKeyDownEscape = (evt) => {
    if (evt.key === KeyboardKeys.ESCAPE) {
      hideInformPopup();
    }
  };

  addCartButton.addEventListener(`click`, async (evt) => {
    evt.preventDefault();
    console.dir(URL, state);
    
    fetchData(URL, state).then((data) => {
      console.dir(data);
      if (data === 200) {
        changeAmountCount(1, AddCartTypes.PLUS);
        showInformPopup();

        informPopupElement.addEventListener(`click`, onPopupClick);
        document.addEventListener(`keydown`, onKeyDownEscape);
      }
    });
  });
};

export default addCart;
